import * as React from 'react';
import { Alert } from '@payscale/design';
import { observer } from 'mobx-react';
import { NotFoundConstantCode } from 'common/errorResponse';
import { RouteComponentProps } from 'react-router-dom';

export interface IParamProps {
    code: string;
}

interface INotFoundErrorRouteProps extends RouteComponentProps<IParamProps>,
    React.Props<IParamProps>, IParamProps {
}

@observer
export default class NotFoundErrorView extends React.Component<INotFoundErrorRouteProps> {
    render(): React.ReactNode {
        return (
            <div className="container pxl-margin-top-lg">
                <Alert
                    level="warning"
                    message={this.renderErrorMessage()}
                    close={false}
                />
            </div>
        );
    }

    private renderErrorMessage(): React.ReactNode {
        const { match } = this.props;
        if (match.params.code === NotFoundConstantCode.Cycle) {
            return (
                <span>
                    <b>There is no cycle configuration, you cannot continue using this application.</b>
                    <br />
                    <span>Please contact your administrator.</span>
                </span>
            );
        }

        return (
            <span>
                <b>Cannot find the requested page.</b>
            </span>
        );
    }
}